// extracted by mini-css-extract-plugin
export default {"card-face-toggle":"card-face-toggle_card-face-toggle__3+Kfv"};